//Get Genre
export const GET_GENRE = "GET_GENRE";

//Insert Genre
export const INSERT_GENRE = "INSERT_GENRE";

//Update Genre
export const UPDATE_GENRE = "UPDATE_GENRE";

//Delete Genre
export const DELETE_GENRE = "DELETE_GENRE";

//Toggle Status
export const TOGGLE_GENRE_STATUS = "TOGGLE_GENRE_STATUS";

//Insert Open Dialog
export const OPEN_GENRE_DIALOG = "OPEN_GENRE_DIALOG";

//Close Dialog
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//toast
export const OPEN_GENRE_TOAST = "OPEN_GENRE_TOAST";
export const CLOSE_GENRE_TOAST = "CLOSE_GENRE_TOAST";
